import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';
import { safeReturnUrl } from 'app/core/auth/return-url';
import { map } from 'rxjs';

/**
 * Strony panelu tylko z sesją; bez niej — logowanie z powrotem na tę stronę (`?powrot=`). Po wygaśnięciu sesji
 * AuthService zostawia w karcie komunikat „Sesja wygasła” dla ekranu logowania.
 */
export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const auth = inject(AuthService);

    return auth.check().pipe(
        map((session) => {
            if (session === 'ok') {
                return true;
            }

            const powrot = safeReturnUrl(state.url);

            return router.createUrlTree(['/logowanie'], { queryParams: powrot && powrot !== '/' ? { powrot } : {} });
        })
    );
};
